import Card from "../models/Card";
import axios from "axios";
import { Channel, ItemType, Location, ActionType } from '../enums';
export default async function () {
  const RecSvc = {
    async getRecommendationItems(data) {
      if (data) {
        var params = new URLSearchParams();
        data.userId && params.append("OnlineSluttKundeId", data.userId);
        data.siteIds &&
          data.siteIds.forEach((siteId) => {
            params.append("SiteIds", siteId);
          });
        if (data.itemType != null) {
          params.append("ItemType", data.itemType);
        }
        data.chainId && params.append("ChainId", data.chainId);
        if (data.location != null) {
          params.append("Location", data.location);
        }

        data.channel && params.append("Channel", data.channel);
        data.quantity && params.append("Quantity", data.quantity);
        data.employeeId && params.append("EmployeeId", data.employeeId);
        data.treatmentIds &&
          data.treatmentIds.forEach((treatmentId) => {
            params.append("ItemIdsList.TreatmentIds", treatmentId);
          });
        data.productIds &&
          data.productIds.forEach((productId) => {
            params.append("ItemIdsList.ProductIds", productId);
          });
        data.cartItemsIds &&
          data.cartItemsIds.forEach((id) => {
            params.append("CartItemsIds", id);
          });
      }
      return await axios
        .get(`${data.urlBase}get-recommendations`, {
          params: params,
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            let items = [];
            if (response.data) {
              items = response.data.map((c) => new Card(c));
            }
            return items;
          }
        })
        .catch(function (err) {
          if (err) {
            console.log("No data!");
          }
          return [];
        });
    },
    async logUserActivity(data){
    
      if (!window && !window.cookie && !window.cookie.allowedCategory('analytics')) return;

      let clientId = localStorage.getItem('clientId');
      let itemsLogged = JSON.parse(sessionStorage.getItem('items_logged')) || [];

      if (!clientId && !data.isLoggedIn) {
          clientId = self.crypto.randomUUID();
          localStorage.setItem('clientId', clientId);
      }

      if (!sessionStorage.getItem("session_id")) {
          sessionStorage.setItem("session_id", self.crypto.randomUUID());
      }

      if (data.isLoggedIn) {
          sessionStorage.removeItem("items_logged");
          itemsLogged = [];
      }
        const deviceType = navigator.userAgentData.mobile ? 'Phone' : 'Computer';
        const params = {
          "UserId": data.userId ?? clientId,
          "IsLoggedIn": data.isLoggedIn,
          "ChainId": data.chainId,
          "SiteIds": data.siteIds,
          "SessionId": sessionStorage.getItem("session_id"),
          "RankingSource": data.rankingSource,
          "DeviceType": deviceType,
          "Location": data.location,
          "Channel": data.channel,
          "ActionType": data.actionType,
          "ItemId": data.itemId,
          "ItemType": data.itemType,
          //"ParentId": data.parentId
        };
        try {
          let shouldLog = true;

          if (data.location === Location.HOME_PAGE && data.actionType === ActionType.Recommended) {
              shouldLog = !itemsLogged.some(item => item.itemId === data.itemId && item.location === data.location && item.actionType === ActionType.Recommended);
          } else if (data.location === Location.TREATMENT_PAGE && data.parentId && data.actionType === ActionType.Recommended) {
              shouldLog = !itemsLogged.some(item => item.parentId === data.parentId && item.location === data.location && item.itemId === data.itemId && item.actionType === ActionType.Recommended);
          } else if (data.location === Location.EMPLOYEE_PAGE && data.parentId && data.actionType === ActionType.Recommended) {
            shouldLog = !itemsLogged.some(item => item.parentId === data.parentId && item.location === data.location && item.itemId === data.itemId && item.actionType === ActionType.Recommended);
          } else if (data.location === Location.CART && data.actionType === ActionType.Recommended) {
            shouldLog = !itemsLogged.some(item => item.location === data.location && item.itemId === data.itemId && item.actionType === ActionType.Recommended);
          }

          if (shouldLog) {
              const response = await axios.post(`${data.urlBase}create-log-for-user-behaviour`, params);
              if (response.status === 200) {
                  itemsLogged.push({ itemId: data.itemId, location: data.location, actionType: data.actionType, parentId: data.parentId });
                  sessionStorage.setItem("items_logged", JSON.stringify(itemsLogged));
              }
          }
      } catch (err) {
          console.error(`Call failed: ${err}`);
      }
    }
  };
  function generateClientId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }
  return RecSvc;
}
